<template>

  <div class="container">

    <div class="row">

    <div v-if="!loaded" class="modal fade bd-example-modal-lg show d-block" data-backdrop="static" data-keyboard="false" tabindex="-1">
      <div class="modal-dialog modal-sm" >
          <div class="modal-content">
              <img alt="Trackd Music" src="../assets/trackd-loading.gif" height="50" class=" d-block mx-auto" />
          </div>
      </div>
    </div>
    
      <div v-if="loaded" class="col-12 offset-0 col-md-6 offset-md-3 text-center">

        <h4 class="mb-4 menu-dark font-weight-light">Payments</h4>

        <b-table class="bg-white" v-if="payments" :items="payments" :fields="fields">

        </b-table>

      </div>

    </div>

  </div>

</template>

<script>

import axios from 'axios';

export default {
  name: 'Payments',
  data() {
    return  {
      loaded: false,
      payments: [],
      fields: [
          { key: 'username', label: 'Made By' },
          { key: 'location', label: 'Location' },
          { key: 'amount', label: 'Amount' },
          { key: 'status', label: 'Status' },
      ]
    }
  },
  methods: {
    loadData () {

      let token = null;

      try {
        token = this.$store.getters.getToken.access
      } catch (err) {
        this.$router.replace({name: 'auth-error'})
      }

      //localStorage.getItem('accessToken')
      let headers = {
        'Authorization': 'JWT ' + token
      }

      axios.get('/chipin/account/payments/', {'headers': headers})
          .then(res => {
            console.log(res.data)
            this.payments = res.data.results
            this.loaded = true
          })
          .catch(error => {
            this.name = 'Sorry something went wrong!';
            console.log(error)
          });

    }
  },
  beforeMount(){
      this.loadData()
   },
}
</script>
